import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Container } from 'components/layout/Container'
import times from 'lodash/times'
import { Pagination } from 'transfix-ui/components/Pagination'
import { Box, Grid, Skeleton } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { MarketplaceLoadDetailsModalContainer } from 'apps/fleet-planner/pages/marketplace/MarketplaceLoadDetailsContainer'
import { useBookableShipmentRecommendations } from 'apps/fleet-planner/types'
import { TopNav } from 'transfix-ui'
import { BookableShipmentSavedSearchAlertPlaceholder } from '../alert/BookableShipmentSavedSearchAlertPlaceholder'
import { BookableShipmentSearchRunItAgainRow } from '../alert/BookableShipmentSearchRunItAgainRow'

const PAGE_SIZE = 10
const LOAD_RECOMMENDATIONS_LIMIT = 3
const INITIAL_PAGE_NUMBER = 1

export const RunItAgainPage = () => {
  const { isMobile } = useBreakpointContext()
  const history = useHistory()

  const {
    data,
    loading: isLoading,
    refetch: refetchBookableShipmentSearch,
  } = useBookableShipmentRecommendations({
    lazy: true,
  })

  const [pageNumber, setPageNumber] = useState<number>(INITIAL_PAGE_NUMBER)
  const [hasSearched, setHasSearched] = useState<boolean>(false)
  const { bookableShipmentSavedSearchRecommendations = [], totalCount = 0 } = data || {}
  const pageCount = Math.floor(totalCount / PAGE_SIZE)
  const pageChangeHandler = (pageCount: number) => {
    return setPageNumber(pageCount)
  }

  // Fetch bookable shipments on page load and on pagination change.
  useEffect(() => {
    refetchBookableShipmentSearch({
      queryParams: {
        sourceTypes: ['auto_historical'],
        limit: LOAD_RECOMMENDATIONS_LIMIT,
        pageNumber,
        pageSize: PAGE_SIZE,
      },
    })
    // hasSearched to determine when to display empty state.
    if (hasSearched === false) {
      setHasSearched(true)
    }
  }, [pageNumber])

  const backButtonHandler = () => history.replace('/book')

  const isPaginationVisible = pageCount > 0 && !isLoading

  return (
    <Box>
      <TopNav showBackButton onPressBackButton={backButtonHandler} title='Run it again' />
      <Container hidePadding>
        {/* Loading state */}
        {isLoading &&
          times(3).map(item => (
            <Box key={item} p={2}>
              <Box pt={4} pl={2}>
                {!isMobile && (
                  <Box pb={3}>
                    <Skeleton variant='rectangular' height='25px' width='453px' />
                  </Box>
                )}
                <Grid container>
                  {times(3).map(item => (
                    <Grid key={item} item md={4} xs={12}>
                      <Skeleton
                        variant='rectangular'
                        height={isMobile ? '80px' : '240px'}
                        width='95%'
                      />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          ))}

        {/* Empty State */}
        {!isLoading && hasSearched && bookableShipmentSavedSearchRecommendations?.length === 0 && (
          <Box pt={1} pl={3} pr={3} pb={3}>
            <BookableShipmentSavedSearchAlertPlaceholder message='Your historical lanes' />
          </Box>
        )}

        {/*  Recommendations */}
        {!isLoading &&
          bookableShipmentSavedSearchRecommendations?.length > 0 &&
          bookableShipmentSavedSearchRecommendations.map(loadRecommendation => {
            const { id: savedSearchId } = loadRecommendation || {}
            return (
              <BookableShipmentSearchRunItAgainRow
                key={savedSearchId}
                loadRecommendation={loadRecommendation}
              />
            )
          })}

        {/*  Pagination */}
        {isPaginationVisible && (
          <Box className='tc'>
            <Pagination
              currentPage={pageNumber}
              numberOfPages={pageCount + 1}
              onPageChange={pageChangeHandler}
            />
          </Box>
        )}
        <MarketplaceLoadDetailsModalContainer route='historical-lanes' />
      </Container>
    </Box>
  )
}
